import apiClient from "../../utils/clients/axios";

export const getVariety = async (date) => {
    const { data } = await apiClient.get(
      `/api/quality_control/autoconer/autoconer-variety-master-data`
    );
  
    return data;
  };